<script setup>
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  LineElement,
  PointElement,
  Filler,
  BarElement,
  TimeSeriesScale,
  TimeScale,
  Tooltip,
} from "chart.js";
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
ChartJS.register(LinearScale, CategoryScale, LineElement, PointElement, BarElement, Filler, TimeSeriesScale, TimeScale, Tooltip)

const props = defineProps({
  datacollection: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  }
});

</script>

<template>
  <div>
    <Line
      :options="options"
      :data="datacollection"
    />
  </div>
</template>